import styled from 'styled-components'
import { H2 } from 'components/typography/heading'
import { Grid } from 'components/grid'
import { ContactSupportEnriched } from 'modals/feature-upgrade/content/contact'

export const Wrap = styled(Grid)`
    grid-auto-rows: auto;
    grid-auto-flow: row;
    grid-row-gap: 24px;
`

export const Heading = styled(H2)`
    margin: 0;
`

export const ContactFrame = styled.div`
    border-radius: 8px;
    padding: 8px;
    background-color: var(--huma-color-surface-success-minimal);
`

export const ContactFrameInner = styled.div`
    position: relative;
    overflow: hidden;

    border-radius: 4px;
    padding: 16px;
    background-color: var(--huma-color-surface-default);
    box-shadow: var(--huma-shadow-lower);
`

export const ContactSupport = styled(ContactSupportEnriched)`
    padding: 0;
`